import {Injectable, inject} from '@angular/core';
import {PurchaseFlowEventHandlerInterface, PurchaseFlowEventType, PurchaseFlowEventTypeEnum, PurchaseFlowStepEnum} from '@wellfit/wf-plans-widget';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';

const STEP_KEYS: Record<PurchaseFlowStepEnum, string> = {
  [PurchaseFlowStepEnum.Applicants]: 'form_step_1',
  [PurchaseFlowStepEnum.Billing]: 'form_step_2'
};

@Injectable()
export class SgdpGaEventHandler implements PurchaseFlowEventHandlerInterface {
  private _googleAnalyticsService: GoogleAnalyticsService = inject(GoogleAnalyticsService);

  public handle(event: PurchaseFlowEventType): void {
    switch (event.type) {
      case PurchaseFlowEventTypeEnum.PlanSelected:
        this._googleAnalyticsService.sendKeyEvent('choose_your_plan', {planName: event.planName});
        break;
      case PurchaseFlowEventTypeEnum.StepCompleted:
        this._googleAnalyticsService.sendKeyEvent(STEP_KEYS[event.step], {});
        break;
      case PurchaseFlowEventTypeEnum.FamilyMemberAdded:
        this._googleAnalyticsService.sendKeyEvent('add_family_member', {});
        break;
      case PurchaseFlowEventTypeEnum.PurchaseCompleted:
        this._googleAnalyticsService.sendKeyEvent('purchase_plan', {});
        break;
    }
  }
}
